import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { NavLink } from 'react-router-dom';

export function Navigation({ to, children, icon }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        isActive
          ? 'mx-1 flex flex-col items-center justify-center rounded-2xl px-3 py-1 text-start font-semibold text-indigo-600 opacity-90 dark:text-indigo-400 lg:flex-row lg:gap-2 lg:rounded-full lg:py-3 lg:text-2xl lg:shadow-none'
          : 'mx-1 flex flex-col items-center justify-center rounded-2xl px-3 py-1 text-start opacity-80 hover:bg-indigo-400/20 hover:text-indigo-900 hover:opacity-100 hover:shadow-sm dark:hover:bg-indigo-700/20 dark:hover:text-indigo-100 lg:flex-row lg:gap-2 lg:rounded-full lg:py-3 lg:text-2xl lg:font-semibold lg:shadow-none'
      }
    >
      <Icon icon={icon} className="text-3xl" />
      <span className="text-xs font-normal lg:text-2xl">{children}</span>
    </NavLink>
  );
}

Navigation.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
